import filters from '../../facet-filter/facet-filter.es6';
import search from '../../form/search/search.es6';


let activeFacets;
let selectedTags;

function tagsBusy( busy ) {
	if( !activeFacets ) { return; }
	if( busy ) {
		activeFacets.style.display ='none';
	}
}

function renderTag( id, tagData ) {
	return `<label for="${filters.normalizeId( id, tagData )}" class="tag tag--large tag--close-icon">${tagData.values.label}</label>`;
}

function errorState() {
	if( !activeFacets ) { return; }
	activeFacets.style.display = 'none';
}

function renderTags( results ) {
	if( !activeFacets || !results?.meta?.facets ) {
		errorState();
		return;
	}

	let htmlStr = '';
	let countActive = 0;

	// Create tag for search term
	let searchTerm = search.retrieveSearchTerm(results)
	
	if ( searchTerm ) {
		htmlStr += `<label for="active-facets-clear-button" class="tag tag--large tag--close-icon">${decodeURI(searchTerm)}</label>`;
		countActive += 1;
	}
	
	// Create tags for facet terms
	const filteredFacets = filters.cleanFacets(results.meta.facets);

	filteredFacets.forEach( facet => {
		facet.terms.forEach( term => {
			if( term.children ) {
				term.children[0].forEach( childTerm => {
					if( childTerm.values.active ) {
						countActive += 1;
						htmlStr += renderTag( facet.id, childTerm );
					}
				} );
			} else if( term.values.active ) {
				countActive += 1;
				htmlStr += renderTag( facet.id, term );
			}
		} );
	} );

	selectedTags.innerHTML = htmlStr;

	if( countActive ) {
		activeFacets.querySelector( '.active-facets__count' ).textContent = countActive;
		activeFacets.style.display = 'block';

		if( countActive >= 5 ) {
			activeFacets.classList.add( 'active-facets--many' );
		} else {
			activeFacets.classList.remove( 'active-facets--many' );
		}

	} else {
		activeFacets.style.display = 'none';
	}

	filters.addClearAllListener( document.querySelector( '.active-facets__clear' ) );
}

function init() {
	activeFacets = document.querySelector( '.active-facets' );
	
	if(!activeFacets) {
		return; //Prevent error log when .active-facets is not present
	}

	selectedTags = activeFacets.querySelector( '.tag-group' );

	activeFacets.querySelector( '.active-facets__more button' ).addEventListener( 'click', ( e ) => {
		activeFacets.classList.toggle( 'active-facets--expanded' );

		const btn = e.target;
		if( btn.getAttribute( 'aria-expanded' ) === 'true' ) {
			btn.setAttribute( 'aria-expanded', 'false' );
			btn.textContent = btn.dataset.btnAll;
		} else {
			btn.setAttribute( 'aria-expanded', 'true' );
			btn.textContent = btn.dataset.btnLess;
		}
	});
}

if (
	document.readyState === "complete" ||
	(document.readyState !== "loading" && !document.documentElement.doScroll)
) {
	init();
} else {
	let eventSrcUrl = null;
	document.addEventListener('DOMContentLoaded', ( e ) => {
		if( eventSrcUrl !== e.target.URL ) {
			eventSrcUrl = e.target.URL
			init();
		}
	} );
}


export default {
	renderTags, // call this when the page recieves new data
	tagsBusy, // call this when the page initiates a new request
};